import VerticalTable from "@components/VerticalTable"
import { ExpandMore } from "@mui/icons-material"
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material"
import { NodeTagDto } from "@store/services/converter/types"
import { useLocalStorage } from "usehooks-ts"

type NodeTagsAccordionProps = {
  tags: NodeTagDto[]
}

const NodeTagsAccordion = (props: NodeTagsAccordionProps) => {
  const [expanded, setExpanded] = useLocalStorage(`nodeTagsAccordionExpanded`, true)

  if (props.tags.length === 0) return

  const rows = props.tags.map((tag) => ({
    label: tag.Name,
    value: tag.Value,
  }))

  return (
    <Grid item sx={{ width: expanded ? "auto" : "100%" }}>
      <Accordion expanded={expanded} onChange={(_event, isExpanded) => setExpanded(isExpanded)}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography sx={{ fontWeight: 700 }}>Node Tags:</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          <VerticalTable headers={["Tag", "Value"]} rows={rows} />
        </AccordionDetails>
      </Accordion>
    </Grid>
  )
}

export default NodeTagsAccordion
